import React from 'react'
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined'
import ChildFriendlyOutlinedIcon from '@mui/icons-material/ChildFriendlyOutlined'
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

import type { StayOption } from '@/src/utils/holidays/parseStayOptions'

import StayOptions, { type StayOptionView } from './stayOptions'

interface StayOptionsWrapperProps {
    options: StayOption[]
    caption?: string
    isMobile: boolean
}

/** Most specific first: "child sharing" must beat the bare "sharing" that names twin/triple. */
const ICON_RULES: Array<[RegExp, StayOptionView['Icon']]> = [
    [/infant/i, ChildFriendlyOutlinedIcon],
    [/child/i, ChildCareOutlinedIcon],
    [/single/i, PersonOutlineIcon],
    [/twin|triple|sharing|double/i, GroupOutlinedIcon]
]

const iconFor = (label: string): StayOptionView['Icon'] => {
    for (const [pattern, Icon] of ICON_RULES) if (pattern.test(label)) return Icon
    return PersonOutlineIcon
}

const StayOptionsWrapper: React.FC<StayOptionsWrapperProps> = ({ options, caption, isMobile }) => {
    if (!options.length) return null

    const views: StayOptionView[] = options.map(option => ({
        label: option.label,
        price: option.price,
        Icon: iconFor(option.label)
    }))

    return <StayOptions options={views} caption={caption} isMobile={isMobile} />
}

export { StayOptionsWrapper }
export default StayOptionsWrapper
